import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from '../Screens/Home';
import About from '../Screens/About';
import BusinessModule from '../Screens/BusinessModule';
import Services from '../Screens/Services';
import Projects from '../Screens/Projects';
import Contact from '../Screens/Contact';
import Footer from '../Components/Footer';
import OurTeam from '../Screens/OurTeam';


import ProjectDetails from '../Screens/ProjectDetails';
import TeamMemberDetails from '../Screens/TeamMemberDetails';
import SecTeamMemberDetails from '../Screens/SecTeamMemberDetails';

import CombinedCards from '../Components/CombinedCards';
import CookieConsent from '../Components/CookieConsent';
import OurServices from '../Components/OurServices';
import USAMap from '../Screens/USAMap';
import OrgChart from '../Screens/OrgChart';
import JourneyTimeline from '../Components/JourneyTimeline';



const Nav = () => {
  const appStyle = {
    background: 'linear-gradient(to right, #0f2027, #203a43, #2c5364)',
    minHeight: '100vh',
    color: 'white', // Changed to white for visibility
  };

  return (

    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/home" element={<Home />} />
      <Route path="/About" element={<About />} />
      <Route path="/BusinessModule" element={<BusinessModule />} />
      <Route path="/OurServices" element={<OurServices />} />
      <Route path="/Projects" element={<Projects />} />
      <Route path="/OurTeam" element={<OurTeam />} />
      <Route path="/Contact" element={<Contact />} />
      <Route path="/Footer" element={<Footer />} />

      <Route path="/projectdetails" element={<ProjectDetails />} />
      <Route path="/cookies" element={<CookieConsent />} />

      <Route path="/team-member-details" element={<TeamMemberDetails />} />
      <Route path="/SecTeamMemberDetails" element={<SecTeamMemberDetails />} />
      <Route path="/CombinedCards" element={<CombinedCards />} />
      <Route path="/USAMap" element={<USAMap />} />
      <Route path="/OrgChart" element={<OrgChart />} />
      <Route path="/JourneyTimeline" element={<JourneyTimeline />} />




    </Routes>


  );
};

export default Nav;
